module.exports = __webpack_public_path__ + "img/icon-send-02.svg";